module.exports = __webpack_public_path__ + "img/TITAN-AspirationCatheter-1-584x584.42309eb6.webp";